"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const customInnerIconCN = (type) => {
    return (0, classnames_template_literals_1.default)(`
    flex
    justify-center
    items-center
    text-n-000
    ${type == 'rounded' && 'rounded-full'}
    ${type == 'square' && 'rounded-md'}
  `);
};
const defaultProps = {
    backgroundColor: `var(--base-600)`,
    size: 24,
    type: 'rounded',
    borderColor: `var(--base-600)`,
    iconColor: `#FFF`,
    iconText: ''
};
const CustomInnerIcon = ({ backgroundColor, borderColor, type = 'rounded', size = 24, iconColor, iconName, iconText, iconSize = 16, iconCustomClass }) => {
    return (react_1.default.createElement("div", { className: customInnerIconCN(type), style: {
            backgroundColor: backgroundColor,
            width: `${size}px`,
            height: `${size}px`,
            border: `1px solid ${borderColor}`
        } }, iconName ? (react_1.default.createElement(SVGIcon_1.default, { size: iconSize, iconName: iconName, fillColor: iconColor, customClass: iconCustomClass })) : (iconText)));
};
CustomInnerIcon.defaultProps = defaultProps;
exports.default = CustomInnerIcon;
